import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ToolkitHero from './components/ToolkitHero';
import ToolkitGrid from './components/ToolkitGrid';
import { useSEO } from '../../utils/seo';

export default function Toolkits() {
  useSEO({
    title: 'Real Estate Toolkits & Resources | eXp Realty Agent Tools | Jeffery Long California',
    description: 'Access all real estate toolkits, agent resources, and business tools in one place. Curated tools for buyers, sellers, and eXp Realty agents in Northern California. Serving Sacramento, El Dorado Hills, Cameron Park. CA DRE #02234432',
    keywords: 'real estate toolkits, eXp Realty tools, agent resources, real estate business tools, California realtor resources, buyer tools, seller tools, real estate technology, MLS tools, Sacramento agent',
    canonical: '/toolkits',
    ogTitle: 'Real Estate Toolkits & Agent Resources | Jeffery Long eXp Realty',
    ogDescription: 'All the real estate tools and resources you need in one convenient place. Curated toolkits for buyers, sellers, and agents.',
    ogImage: 'https://public.readdy.ai/ai/img_res/bc6528b8c716929fc2f5ff266fb78c00.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Real Estate Toolkits & Resources',
      description: 'Comprehensive collection of real estate toolkits, agent resources, and business tools for buyers, sellers, and eXp Realty agents in Northern California.',
      url: 'SITE_URL/toolkits',
      provider: {
        '@type': 'RealEstateAgent',
        name: 'Jeffery Long - eXp Realty',
        telephone: '+1-916-257-8244',
        url: 'SITE_URL',
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: 'SITE_URL/' },
          { '@type': 'ListItem', position: 2, name: 'Toolkits', item: 'SITE_URL/toolkits' },
        ],
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ToolkitHero />
        <ToolkitGrid />
      </main>
      <Footer />
    </div>
  );
}
